import { create } from "zustand";
import { persist } from "zustand/middleware";

export type LicenseStatus = "VALID" | "INVALID";

export interface License {
  clientName: string;
  serialNumber: string;
  userCount: number;
  validFrom: string;
  validTo: string;
}

export interface LicenseStore {
  license: License;
  reason: string | null;
  status: LicenseStatus;
  setLicense: (payload: {
    license: License;
    reason: string | null;
    status: LicenseStatus;
  }) => void;
  reset: () => void;
}

const initialState: LicenseStore["license"] = {
  clientName: "",
  serialNumber: "",
  userCount: 0,
  validFrom: "",
  validTo: "",
};

export const useLicenseStore = create<LicenseStore>()(
  persist(
    set => ({
      license: initialState,
      reason: null,
      reset: () =>
        set(() => ({
          license: initialState,
          reason: null,
          status: "INVALID",
        })),
      setLicense: ({ license, reason, status }) =>
        set(() => ({
          license,
          reason,
          status,
        })),
      status: "INVALID",
    }),
    {
      name: "license-store", // ключ в localStorage
    },
  ),
);
